import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=4ea10af4&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=4ea10af4&prod&scoped=true&lang=css"
import style1 from "./reg.vue?vue&type=style&index=1&id=4ea10af4&prod&lang=css"
import style2 from "./reg.vue?vue&type=style&index=2&id=4ea10af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea10af4",
  null
  
)

export default component.exports